import { render, staticRenderFns } from "./VerDetalleConvocatoriaDialogComponent.vue?vue&type=template&id=6971e538"
import script from "./VerDetalleConvocatoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./VerDetalleConvocatoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports